import { BASE_URL_LEGACY } from "./";

export const energyService = {
  getTodayStatus,
  getDailyStatus,
  getUsedAppliances,
  getDetail,
  getTimeline,
};

function getTimeline(user, timestamp) {
  const requestOptions = {
    method: "GET",
    headers: { "Content-Type": "application/json" },
    credentials: "include",
  };

  return fetch(
    `${BASE_URL_LEGACY}/common/appliances/timeline/?user_id=${user}&timestamp=${timestamp}`,
    requestOptions
  )
    .then((response) => {
      if (!response.ok) {
        return Promise.reject(response.statusText);
      }

      return response.json();
    })
    .then((detail) => {
      return detail;
    });
}

function getTodayStatus(user, timestamp) {
  const requestOptions = {
    method: "GET",
    headers: { "Content-Type": "application/json" },
    credentials: "include",
  };

  return fetch(
    `${BASE_URL_LEGACY}/energy_info/today/?user_id=${user.user_id}&timestamp=${timestamp}`,
    requestOptions
  )
    .then((response) => {
      return handleResponse(response);
    })
    .then((detail) => {
      return detail;
    });
}

function getDailyStatus(user, timestamp, timescale = "day") {
  const requestOptions = {
    method: "GET",
    headers: { "Content-Type": "application/json" },
    credentials: "include",
  };

  return fetch(
    `${BASE_URL_LEGACY}/energy_info/detail/?user_id=${user.user_id}&timestamp=${timestamp}&timescale=day`,
    requestOptions
  )
    .then((response) => {
      return handleResponse(response);
    })
    .then((detail) => {
      return detail;
    });
}

function getUsedAppliances(timescale = "day") {
  const requestOptions = {
    method: "GET",
    headers: { "Content-Type": "application/json" },
    credentials: "include",
  };

  return fetch(
    `${BASE_URL_LEGACY}/common/used_appliances/?timescale=${timescale}`,
    requestOptions
  )
    .then((response) => {
      return handleResponse(response);
    })
    .then((detail) => {
      return detail;
    });
}

function getDetail(user, timescale, timestamp) {
  const requestOptions = {
    method: "GET",
    headers: { "Content-Type": "application/json" },
    credentials: "include",
  };

  return fetch(
    `${BASE_URL_LEGACY}/energy_info/detail/?user_id=${user.user_id}&timescale=${timescale}&timestamp=${timestamp}`,
    requestOptions
  )
    .then((response) => {
      return handleResponse(response);
    })
    .then((detail) => {
      return detail;
    });
}

function handleResponse(response) {
  if (!response.ok) {
    return Promise.reject(response.statusText);
  }

  return response.json();
}
